var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiktokIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 799.7 960",
    style: {
      enableBackground: "new 0 0 799.7 960"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M700.1,205.3c-6.2-3.3-12.3-7-18.2-11c-17.1-11.8-32.7-25.6-46.6-41.2c-34.8-41.4-47.8-83.4-52.6-112.9h0.2 c-4-24.4-2.3-40.2-2.1-40.2H422.4v637.5c0,8.6,0,17-0.3,25.4c0,1-0.1,2-0.2,3.1c0,0.5,0,0.9-0.1,1.4c0,0.1,0,0.2,0,0.4 c-3.4,46.5-28.8,88.1-67.7,111.1c-20,11.8-42.6,18-65.6,18c-73.8,0-133.7-62.6-133.7-140s59.8-140,133.7-140c14,0,27.9,2.3,41.2,6.8 l0.2-167.9c-81.6-11-163.8,14.1-226.8,69c-27.3,24.7-50.3,54.2-67.9,87.1c-6.7,12-31.9,60.2-35,138.5c-1.9,44.4,10.9,90.4,17,109.5 v0.4c3.8,11.2,18.7,49.4,43,81.6c19.6,25.8,42.7,48.5,68.6,67.4v-0.4l0.4,0.4C206,963.5,291,960,291,960c14.7-0.6,64,0,120.1-27.6 c62.1-30.6,97.5-76.2,97.5-76.2c22.6-27.3,40.6-58.3,53.1-91.9C576,725,580.8,678,580.8,659.2V321c1.9,1.2,27.5,18.8,27.5,18.8 s36.9,24.6,94.4,40.6c41.3,11.4,96.9,13.8,96.9,13.8V230.5C780.2,232.7,740.6,226.3,700.1,205.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokIcon);
export default __webpack_public_path__ + "static/media/tiktok_icon.bf08d1244c1f389483a3d6972ea53b21.svg";
export { ForwardRef as ReactComponent };